import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CourseService } from '@app/core/services/course.service';
import { safeEmpty } from '@app/shared/utils';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';
import { CourseSelectors } from '../store';
import { CourseResolverData } from './course.resolver';

export const vitrineResolver: ResolveFn<CourseResolverData> = (route, state) => {
  const courseService = inject(CourseService);
  const store = inject(Store);

  return store.select(CourseSelectors.courseActive).pipe(
    switchMap(() => courseService.getTrailByVitrine(route.params.trail_slug).pipe(safeEmpty())),
    switchMap((course) => {
      const data: CourseResolverData = {
        courseResponse: undefined,
        selectedSession: undefined,
        selectedElement: undefined,
        selectedElementData: undefined,
      };

      data.courseResponse = { ...course, vitrine: true };
      data.selectedSession =
        course.porcentagem < 100
          ? course.sessoes.find((s) => s.elementos.some((e) => e.finalizado === 0))
          : course.sessoes[0];
      data.selectedElement = data.selectedSession.elementos.some((e) => e.finalizado === 0)
        ? data.selectedSession.elementos.find((e) => e.finalizado === 0)
        : data.selectedSession.elementos[0];

      return courseService.getElementByVitrine(route.params.trail_slug, data.selectedElement.slug).pipe(
        safeEmpty(),
        map((element) => {
          data.selectedElementData = element;
          return data;
        }),
      );
    }),
  );
};
